import { useEffect, useState } from "react";
import { api, queryString } from "../api.js";
import { ErrorBox, Pager, fmtRelative } from "../components/helpers.jsx";

const LIMIT = 50;

export default function AdminLogins() {
    const [data, setData] = useState({ rows: [], total: 0 });
    const [offset, setOffset] = useState(0);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/admin-logins" + queryString({ limit: LIMIT, offset }))
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [offset]);

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Dashboard login audit</h1>
                    <div className="sub">Every login attempt — success or fail.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>

            <div className="table-wrap">
                <table className="data">
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Username</th>
                            <th>IP</th>
                            <th>Outcome</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.length === 0 && (
                            <tr><td colSpan={5} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                No logins yet
                            </td></tr>
                        )}
                        {data.rows.map((r) => (
                            <tr key={r.id}>
                                <td title={new Date(r.createdAt).toLocaleString()}>{fmtRelative(r.createdAt)}</td>
                                <td className="mono">{r.username}</td>
                                <td className="mono text-dim">{r.ip ?? "—"}</td>
                                <td>
                                    <span className={`pill ${r.success ? "allow" : "ban"}`}>
                                        {r.success ? "success" : "fail"}
                                    </span>
                                </td>
                                <td className="text-dim">{r.reason ?? "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager total={data.total} limit={LIMIT} offset={offset} onChange={setOffset} />
            </div>
        </>
    );
}
